import { useContext } from 'react'
import { Toggle } from '@/components/ui'
import { formatDate, formatPrice } from '@/utils/formatters'
import BienContext from '@/features/biens/BienContext'
import DataContainer from '../../common/DataContainer'
import DetailsLogement from './DetailsLogement'
import QuittancesLocataire from './QuittancesLocataire'
import LegalDocumentFiles from '../../common/LegalDocumentFiles'
import Interventions from './Interventions'
import Activities from '../../common/Activities'
import RibInfo from './RibInfo'

const LocationTerminee = () => {
  const { bien } = useContext(BienContext)
  const location = bien?.location

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        <DetailsLogement bien={bien} location={location} />

        <div className='overflow-hidden'>
          <h3 className="text-md font-semibold mb-2">Votre départ du logement</h3>
          <div className="w-full bg-primary-100 p-4 rounded-none space-y-4 h-full">
            <div className="flex flex-col gap-4">

              <div className="flex flex-wrap items-center space-x-6 space-y-2"> 
                <DataContainer label="Solde loyer" value={formatPrice(location?.montant_loyer_solde_sortie)} />
                <Toggle.Display label="Reçu" value={location?.loyer_solde_recu} />
              </div>
              
              <DataContainer
                label="Date d'état des lieux"
                value={formatDate(location?.date_etat_lieux_sortie)}
              />

              <DataContainer
                label="Date de fin du bail"
                value={formatDate(location?.date_fin_bail)}
              />
            </div>
            <RibInfo />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
        {/* Quittances */}
        <QuittancesLocataire />

        {/* Documents */}
        <LegalDocumentFiles />
      </div>

      {/* Historique des interventions */}
      <Interventions />

      {/* Historique des activités */}
      <Activities />
    </div>
  )
}

export default LocationTerminee